export default {
  "errors": {
    "notFound": "Event not found.",
    "disabled": "Online RSVPs are not enabled for this event.",
    "loadError": "Unable to load the page.",
    "searchError": "We couldn't find your invitation. Please check the exact spelling used on your invitation.",
    "genericError": "An error occurred.",
    "submitError": "Error submitting your response."
  },
  "success": {
    "title": "Thank you!",
    "message": "Your response has been successfully recorded.",
    "dateMessage": "See you on {{date}}!"
  },
  "header": {
    "title": "RSVP",
    "defaultWelcome": "We look forward to celebrating with you! Please confirm your attendance."
  },
  "search": {
    "title": "Find your invitation",
    "firstName": "First Name",
    "firstNamePlaceholder": "John",
    "lastName": "Last Name",
    "lastNamePlaceholder": "Doe (Optional)",
    "submit": "Search",
    "searching": "Searching..."
  },
  "form": {
    "greeting": "Hello, {{firstName}} {{lastName}}!",
    "subtitle": "Please let us know if you'll be joining us.",
    "attendance": "Will you be attending?",
    "yes": "Yes, I will attend!",
    "no": "No, I cannot attend",
    "plusOne": {
      "title": "Your plus one (+1)",
      "label": "Plus one's First and Last Name",
      "placeholder": "Mary Smith"
    },
    "dietary": {
      "title": "Dietary Requirements",
      "subtitle": "Check the options that apply to you (and your plus one if applicable).",
      "vegetarian": "Vegetarian",
      "vegan": "Vegan",
      "glutenFree": "Gluten Free",
      "porkFree": "Pork Free",
      "nutAllergy": "Nut Allergy",
      "seafoodAllergy": "Seafood Allergy",
      "customPlaceholder": "Other details (specific allergies...)"
    },
    "message": {
      "title": "A message for the couple?",
      "placeholder": "Leave a sweet note..."
    },
    "submit": "Confirm my response",
    "submitting": "Confirming..."
  }
};
